export const ChineseText = {
    // 导航和任务页面通用文本
    myDepartmentTitle: "我的部门",
    myTeamTitle: "我的团队",
    myTaskTitle: "我的任务",
    assignedTaskTitle: "分配给我的任务",
    taskAssignedByMeTitle: "我分配出去的任务",
    myTaskListTitle: "我的任务列表",
    taskNavigationTitle: "任务导航",
    taskDateLocale: "zh-CN",
    taskMonthNames: [
        "一月", "二月", "三月", "四月", "五月", "六月",
        "七月", "八月", "九月", "十月", "十一月", "十二月"
    ],
    assignTaskTitle: "分配任务",
    assignTaskButton: "创建任务",
    createTaskTitle: "创建任务",
    editTaskTitle: "编辑任务",
    myWorkTitle: "我的工作",
    myWorkSubtitle: "保持专注，持续推进，结果自然会出现。",
    myDepartmentSubtitle: "查看您的汇报关系、直属下级和部门任务入口。",
    departmentOverviewTitle: "部门概览",
    departmentOverviewSubtitle: "汇总信息来自组织汇报结构。",
    departmentTeamsSubtitle: "团队成员和部门结构将在这里显示。",
    departmentLoadError: "无法加载部门信息。",
    departmentCurrentPerson: "当前人员",
    departmentDirectReports: "直属下级",
    departmentTotalReports: "下级总数",
    departmentUnderCommandTitle: "我的下级",
    departmentNoDirectReports: "暂未找到您的直属下级。",
    departmentTheirReports: "其下级",
    departmentTopLevel: "组织最高层",
    departmentNotAssigned: "未分配",
    departmentNoEmployeeId: "暂无员工编号",
    departmentGENERAL: "综合部",
    departmentTECHNICAL: "技术部",
    departmentMARKETING: "市场部",
    departmentSALES: "销售部",
    departmentADMIN: "管理部",
    positionBOSS: "老板",
    positionGENERAL_MANAGER: "总经理",
    positionMANAGER: "经理",
    positionASSISTANT_MANAGER: "副经理",
    positionEXECUTIVE: "专员",
    positionADMIN: "管理员",
    noTaskFound: "暂无任务",
    noRecordsFound: "暂无记录",
    askManagerTaskMessage: "请联系经理为你分配任务。",
    cdpLoading: "加载中...",
    searchButton: "搜索",
    resetButton: "重置",
    previousButton: "上一页",
    nextButton: "下一页",
    cancelManagingUser: "取消",
    cdpCancelBtn: "取消",
    cdpDeleteConfirmTitle: "删除确认",
    saveDataButton: "保存",
    saveChangesButton: "保存修改",
    editButton: "编辑",
    deleteButton: "删除",
    commentButton: "评论",

    // 筛选、表格列和统计
    selectYearLabel: "年份",
    selectMonthLabel: "月份",
    selectProjectAll: "全部项目",
    selectCurrentYearLabel: "今年",
    selectLastYearLabel: "去年",
    searchTaskPlaceholder: "搜索任务、项目、接收人...",
    taskSubmissionTimeLabel: "提交时间",
    taskProjectLabel: "项目",
    taskProjectSelectPlaceholder: "选择项目",
    taskProjectCreateButton: "新建项目",
    taskProjectNamePrompt: "项目名称：",
    taskProjectDetailsPrompt: "项目详情：",
    taskOriginalDueDateLabel: "原截止时间",
    taskCurrentDueDateLabel: "当前截止时间",
    taskCompletionDateLabel: "完成时间",
    taskMarkDone: "完成",
    taskColId: "任务ID",
    taskColName: "任务名称",
    taskColTitle: "标题",
    taskColTask: "任务",
    taskColAssigner: "分配人",
    taskColAssignee: "接收人",
    taskColReceiver: "接收人",
    taskColPriority: "优先级",
    taskColDueDate: "截止时间",
    taskColStatus: "状态",
    taskColAction: "操作",
    taskFilterReceiverAll: "接收人：全部",
    taskFilterAssigneeAll: "分配人：全部",
    taskFilterPriorityHighest: "优先级：最高",
    taskFilterStatusAll: "状态：全部",
    taskTotalAssignedLabel: "已分配任务",
    taskCompletionScoreLabel: "完成评分",
    taskFoundCountSingular: "个任务",
    taskFoundCountPlural: "个任务",
    paginationShowing: "显示",
    paginationOf: "共",
    paginationPage: "页",

    // 任务类型、优先级和状态
    taskTypeLabel: "任务类型",
    taskTypeGeneral: "通用任务",
    taskTypeProduct: "产品任务",
    taskTypeMfgProduct: "制造产品任务",
    taskTypeCustomer: "客户任务",
    taskTypeContact: "联系人任务",
    taskPriorityLow: "低",
    taskPriorityMedium: "中",
    taskPriorityHigh: "高",
    taskPriorityUrgent: "紧急",
    taskStatusDraft: "草稿",
    taskStatusAssigned: "已分配",
    taskStatusInProgress: "进行中",
    taskStatusSubmitted: "已提交",
    taskStatusUnderReview: "审核中",
    taskStatusCompleted: "已完成",
    taskStatusDone: "已完成",
    taskStatusOnHold: "已暂停",
    taskStatusCancelled: "已取消",
    taskStatusGivenUp: "已放弃",
    taskStatusLate: "已逾期",
    taskStatusOverdue: "已逾期",
    taskStatusResolution: "延期中",

    // 创建和编辑任务表单
    createTaskSubtitle: "请先创建或选择项目，然后定义可分配的任务。",
    editTaskSubtitle: "更新任务详情并保存修改。",
    createTaskPanelHint: "选择项目后即可填写任务内容。",
    taskCreatedByLabel: "任务创建人",
    currentUserFallback: "当前用户",
    createProjectButton: "创建项目",
    selectProjectButton: "选择项目",
    noProjectSelected: "未选择项目",
    noProjectsFound: "暂无项目。",
    noProjectLabel: "无项目",
    noProjectDescription: "暂无描述。",
    taskNameLabel: "任务名称",
    taskNamePlaceholder: "请输入清晰的一行任务名称",
    taskDescriptionLabel: "描述",
    taskDescriptionPlaceholder: "任务描述",
    taskAttachments: "附件",
    createProjectTitle: "创建项目",
    selectProjectTitle: "选择项目",
    creatorLabel: "创建人",
    projectNameLabel: "项目名称",
    projectNamePlaceholder: "项目名称",
    projectDetailsLabel: "项目详情",
    projectDetailsPlaceholder: "简短项目说明",
    creatingTaskLabel: "正在创建任务...",
    savingTaskLabel: "正在保存任务...",
    creatingProjectLabel: "创建中...",
    loadingProjectsLabel: "正在加载项目...",
    loadingLabel: "加载中...",

    // 分配任务页面和抽屉
    assignTaskSubtitle: "选择已有任务，查看详情，然后为合适人员设置截止时间和备注。",
    chooseTaskTitle: "选择任务",
    loadingAssignmentData: "正在加载任务分配数据...",
    loadingTasksLabel: "正在加载任务...",
    unableLoadAssignmentData: "无法加载任务分配数据。",
    unableSaveAssignment: "无法保存此任务分配。",
    taskDetailsAriaLabel: "任务分配详情",
    taskDescriptionEmpty: "暂无描述。",
    taskDescriptionEmptyShort: "暂无描述",
    addAssignmentTitle: "添加分配",
    editAssignmentTitle: "编辑分配",
    assigneesLabel: "接收人",
    assignerLabel: "分配人",
    selectAssigneePlaceholder: "选择接收人",
    remarksLabel: "备注",
    assignmentRemarksPlaceholder: "添加分配说明、要求或交接信息。",
    savingAssignmentLabel: "正在保存分配...",
    assigningTaskLabel: "正在分配任务...",
    assignTaskSubmitButton: "分配任务",
    savingLabel: "保存中...",
    assigningLabel: "分配中...",

    // 任务详情、历史、评论和删除分配
    taskDetailsAria: "任务详情",
    taskDescriptionTitle: "任务描述",
    taskHistoryTitle: "任务历史",
    taskCreatedHistoryLabel: "任务创建",
    taskAssignedHistoryLabel: "任务分配",
    requestedDueDateHistoryLabel: "申请截止时间",
    reviewedHistoryLabel: "审核",
    submitYourTaskTitle: "提交你的任务",
    commentsTitle: "评论",
    noCommentsYet: "暂无评论。",
    commentPlaceholder: "写一条评论...",
    postingCommentLabel: "正在发布评论...",
    postingLabel: "发布中...",
    submittingTaskLabel: "正在提交任务...",
    approvingSubmissionLabel: "正在批准提交...",
    rejectingSubmissionLabel: "正在拒绝提交...",
    deletingAssignmentLabel: "正在删除分配...",
    failedSubmitTaskResult: "提交任务结果失败。",
    failedApproveSubmission: "批准提交失败。",
    failedRejectSubmission: "拒绝提交失败。",
    failedDeleteAssignment: "删除此分配失败。",
    taskDeleteAssignmentTitle: "删除分配",
    taskDeleteAssignmentMessagePrefix: "这将删除以下接收人的任务分配：",
    taskDeleteAssignmentMessageSuffix: "分配备注中的截图也会被删除。",
    thisAssigneeLabel: "此接收人",
    closeTaskDetailsLabel: "关闭任务详情",
    closeDeleteConfirmationLabel: "关闭删除确认",
    taskImagePreviewAlt: "任务图片预览",

    // 提交和审核
    taskSubmitResultTitle: "提交任务结果",
    submissionTypeFinal: "最终提交",
    submissionTypeResolution: "延期申请",
    submissionTypeModification: "内容修改申请",
    submissionTypeGiveUp: "放弃申请",
    submissionRemarksLabel: "备注",
    submissionRemarksRequired: "请填写备注。",
    submissionResolutionDateLabel: "延期日期",
    submissionResolutionDateRequired: "请填写延期日期。",
    submissionRequestedDueDateLabel: "申请截止时间",
    submissionSubmitButton: "提交",
    submissionListTitle: "任务提交记录",
    submissionColSubmitter: "提交人",
    submissionColType: "类型",
    submissionApproveButton: "批准",
    submissionRejectButton: "拒绝",
    submissionRejectRemarksPrompt: "请输入拒绝原因：",
    submissionReviewRemarksLabel: "审核备注",
    submissionReviewPlaceholder: "添加批准或拒绝备注...",
    rejectingLabel: "拒绝中...",

    // 旧任务表单和关联数据标签
    taskDueDateInputLabel: "截止日期",
    taskDueTimeInputLabel: "截止时间",
    taskDueHourInputLabel: "小时",
    taskDueMinuteInputLabel: "分钟",
    taskLinkedDataLabel: "任务关联信息",
    taskAssigneePlaceholder: "任务接收人",
    taskRequiredAlertPrefix: "请填写",
    cdpFormAttachments: "附件",
    taskPreviewAttachment: "预览",
    taskSearchTitleProduct: "搜索产品",
    taskSearchTitleMfgProduct: "搜索制造产品",
    taskSearchTitleCustomer: "搜索客户",
    taskSearchTitleContact: "搜索联系人",
    taskSelectedItemsTitle: "已选项目",
    taskModifySelectionButton: "修改选择",
    pnProductName: "名称",
    pnProductRemarks: "备注",
    contactImageLabel: "头像",
    contactCompanyLabel: "公司",
    customerLogoLabel: "Logo",
    customerProductsLabel: "产品",
    taskDeleteButton: "删除任务",
    taskDeleteConfirmMessage: "确认删除这个任务吗？",
    taskUpdateStatusButton: "更新状态",
    taskActionsLabel: "任务操作",
    taskAssignPrompt: "想要分配任务给某人吗？",
    taskOpenFormBtn: "打开表单并发送任务。",
    taskInsertScreenshot: "插入截图",
    taskCloseEditor: "关闭编辑器",
    taskAssignmentIdLabel: "分配ID",
    taskAssignedAtLabel: "分配时间",
    taskRemarksLabel: "分配备注"
};
